import { post, get } from '@/common/request';
// 请不要再往这里塞api，用规范写法，不懂就问！
const placeMap = new Map<string, string>([
  ['resList', '/place/page'],
  ['copy', '/tenant/place/fastCreate'],
  ['add', '/property/place/create'],
  ['detail', '/tenant/place/detail'],
  ['analysis', '/tenant/place/detail/analysis'],
  ['edit', '/property/place/update'],
  ['spotList', '/tenant/spot/list'],
  ['roleList', '/tenant/place/role/relation/list'],
  ['visitRecoderList', '/tenant/visitRecord/page'],
  ['addVisit', '/tenant/visitRecord/create'],
  ['tabList', '/tenant/place/resource/tabList'],
  ['placeEamineOrderDetail', '/tenant/examineOrder/place/detail/analysis'],
]);

export interface SearchParams extends City {
  onShelvesStatus?: number[];
  limit?: number;
  offset?: number;
  placeName?: string;
  searchPlaceName?: string;
  placeCategoryIdList?: number[];
  placeLabelIdList?: number[];
  constructionTimeRange?: Range;
  placeAreaRange?: Range;
  spotCountRange?: Range
  supplyCountRange?: Range
}

export interface City {
  provinceIdList?: number[];
  cityIdList?: number[];
  districtIdList?: number[];
}

export interface Range {
  maxValue?: number,
  minValue?: number
}

export interface PlaceInfo {
  tenantPlaceId?: number,
  placeName?: string,
  address?: string,
  categoryId?: number,
  categoryName?: string,
  area?: number;
  constructionTime?: number,
  spotCounr?: number,
  supplierCount?: number;
  buildingLevel?: string
  builtArea?: number,
  businessCircle?: string
  workdayDayAvg?: number;
  placeDescription?: string;
  placeLabelList?: Label[];
  panorama?: File[];
  placePicture?: File[];
  placeVideo?: File[];
  floorPlan?: File[];
  topPropertyList?: any[];
}

export interface File {
  name?: string;
 type?: string;
 url?: string;
}

export interface Label {
    tenantPlaceId?: number,
    tenantLabelId?: number,
    labelName?: string,
    reviewStatus: 1 | 2|3
}

interface Response {
  totalNum?: number;
  pageNum?: number;
  pageSize?: number;
  objectList?: PlaceInfo[]
}

export interface CreateInfo {
  placeName: string,
  placeCategoryId: number,
  area: {
    provinceId: number,
    cityId: number,
    districtId: number
  },
  address: {
    address: string,
    longitude: number,
    latitude: number,
    poiId: number,
    poiName: number
  }
}

export interface Group {
  groupId?: string;
  groupName?:	string;
  propertyList?: Property[];
  propertyGroupConfig?: PropertyValue
}

export interface Property {
  controlType?:	number;
  propertyName?:	string;
  value?: string;
  propertyId?: number;
  propertyValueOptionList?: any[];
  textValue?: any;
  columns?: { title: string, dataIndex: string }[]
}

interface Respone {
  message(message: any): string;
  success: boolean;
  tabs?: any[];
  resourceGroupList?: Group[];
  placeBasicInfo?: PlaceInfo;
  permissions?: any[];
  onShelvesStatus?: number;
  placeHasSpotTableNames?: any[]
}


export interface DetailInfo extends PlaceInfo {
  propertyValueList: PropertyValue[];
  resourcesType: string;

}

export interface PropertyValueEdit {
  propertyId: number;
  textValue?: any;
}

export interface PropertyValue extends PropertyValueEdit {
 categoryPropertyGroupId?: number;
 categoryPropertyGroupConfigId?: number;
 categoryPropertyGroupConfigIdentification?: string;
 controlType?: number;
 propertyValueOptionList?: any[];
}

interface SpotInfo {
  id?: string;
  spotFloor?:	string;
  categoryName?: string;
  spotPosition?: string;
  spotArea?: string
}

interface VisitRecoder {
    id?: number,
    tenantPlaceId?: number,
    supplierId?: number,
    person?: number,
    visitDate?: string,
    visitType?: number,
    otherType?: string,
    employeeId: 100000,
    employeeName?: string,
    entourageEmployeeId: 100000,
    entourageEmployeeName?: number,
    fileContent: [],
    remark?: string,
    longitude?: number,
    latitude?: number,
    address?: string,
    firstVisit?: number
}

interface Tabs {
  tntResourceId?: number,
  resourceType?: number,
  name?: string,
  checked?: boolean;
}

/**
 * 场地列表（分页） 不做用户当前管理项目选项筛选，展示用户能管理的所有场地
 * https://yapi.lanhanba.com/project/355/interface/api/44008
 */
export function postTenantPlacePage(page: number, size: number, searchParams?: SearchParams): Promise<any> {
  return post('/property/place/page', { page, size, ...searchParams }, true);
}

export function postPropertyPlaceOption(searchParams?: SearchParams): Promise<any> {
  return post('/property/place/options', { ...searchParams }, { needCancel: false });
}

// https://yapi.lanhanba.com/project/319/interface/api/65141
export function postV2PropertyPlaceOption(searchParams?: SearchParams): Promise<any> {
  return post('/property/place/options2', { ...searchParams }, { needCancel: false });
}

export function getResList(page: number, size: number, searchParams?: SearchParams): Promise<Response> {
  return post('/place/page', { page, size, ...searchParams }, { needCancel: false, needHint: true, proxyApi: '/resserv' });
}

export function add(info: CreateInfo): Promise<boolean> {
  return post('/property/place/create', info, { needHint: true });
}

export function copyByRes(placeIdList: number[]): Promise<boolean> {
  return post('/tenant/place/fastCreate', { placeIdList }, { proxyApi: '/resserv', needHint: true });
}

export function getInfoBytenantPlaceId(tenantPlaceId: number): Promise<DetailInfo> {
  return post('/tenant/place/detail', { tenantPlaceId }, { proxyApi: '/resserv', needHint: true });
}

export function getAnalysisBytenantPlaceId(tenantPlaceId: number | string, reviewPage?: boolean): Promise<Respone> {
  return post('/tenant/place/detail/analysis', { tenantPlaceId, reviewPage }, { proxyApi: '/resserv', needHint: true });
}

export function placeClaimBytenantPlaceId(id: number | string): Promise<Respone> {
  return post('/property/place/claim', { id }, { needHint: true });
}

export function publicSeaBytenantPlaceId(id: number | string): Promise<Respone> {
  return post('/property/place/relation/role/publicSea', { id }, { needHint: true });
}

export function getPlaceEamineOrderDetailBytenantPlaceId(tenantPlaceId: number | string): Promise<Respone> {
  return post('/tenant/examineOrder/place/detail/analysis', { tenantPlaceId }, { proxyApi: '/resserv', needHint: true });
}

export function edit(tenantPlaceId: number, categoryId: number, propertyValueList: PropertyValueEdit): Promise<boolean> {
  return post('property/place/update', { tenantPlaceId, categoryId, propertyValueList }, { needHint: true });
}

export function deletePlace(tenantPlaceId: number): Promise<boolean> {
  return post('/tenant/place/delete', { tenantPlaceId }, { proxyApi: '/resserv', needHint: true });
}

export function getSpotList(tenantPlaceId: number): Promise<SpotInfo[]> {
  return post('/tenant/spot/list', { tenantPlaceId }, { proxyApi: '/resserv', needHint: true });
}

export function getVisitRecoderList(page: number, size: number, options?: {tenantPlaceId: number}): Promise<{pageSize?: number, pgaeNum?: number, objectList?: VisitRecoder[]}> {
  return post('/tenant/visitRecord/page', { ...options, page, size }, { proxyApi: '/resserv', needHint: true });
}

export function getTabList (resourceType: 0| 1, tntResourceId: number): Promise<Tabs[]> {
  return post('/tenant/place/resource/tabList', { resourceType, tntResourceId }, { proxyApi: '/resserv', needHint: true });
}

/*
*【场地详情】场地关联的角色列表
* https://yapi.lanhanba.com/project/399/interface/api/41229
*/
export function getPlaceRoleList(params: any): Promise<Response> {
  return post('/tenant/place/role/relation/list', params, { needHint: true, proxyApi: '/resserv' });
}

/*
*【【场地管理】检查资源库场地是否存在
* https://yapi.lanhanba.com/project/399/interface/api/45240
*/
export function checkPlaceResourceExist(params: any) {
  return get('/tenant/place/checkResource', params, { needHint: true, proxyApi: '/resserv' });
}

/*
*【场地管理】检查场地地址是否存在
* https://yapi.lanhanba.com/project/399/interface/api/45247
*/
export function checkPoiPlaceExist(params: any) {
  return get('/tenant/place/checkAddress', params, { needHint: true, proxyApi: '/resserv' });
}

export function getOrderResList(params?: any) {
  return post('/tenant/spot/page', { ...params }, { needHint: true, proxyApi: '/resserv' });

}

export function getPlaceAppCode(params): Promise<Response> {
  return get('/property/place/appCode', params, false);
}

// 批量指派提示列表接口
export function getBatchPlaceDetails(params: any) {
  return post('/property/place/relation/role/batchCheckCanBeClaim', { ...params }, {
  });
}

// 批量认领项目
export function batchClaimPlace(params: { ids: number[] }): Promise<Respone> {
  return post('/property/place/batchClaim', params, { needHint: true });
}

// 确认认领场地
export function confirmClaim(params: { ids: number[] }): Promise<Respone> {
  return post('/property/place/confirmClaim', params, { needHint: true });
}

// 暂不用
// 批量指派
// export function batchAssign(params: any) {
//   return post('/api/api/tenant/role/relation/batchAssign', { ...params }, {
//     // isMock: true,
//     proxyApi: ''
//   });
// }



/**
 * 批量复盘
 * https://yapi.lanhanba.com/project/399/interface/api/58827
 */
export function batchReviewRule(params: any) {
  return post('/tenant/review/rule/batchReview/execute', params, { proxyApi: '/resserv' });
}

/**
 * 管理方信息
 */
export function getSupplierDetail(params: any) {
  return post('/tenant/place/supplier/detail', { ...params }, { proxyApi: '/resserv' });
}

/**
 * 快速创建项目-动态模版
 * https://yapi.lanhanba.com/project/399/interface/api/63923
 */
export function getPlaceTemplate(params: any) {
  return post('/tenant/place/template', { ...params }, { proxyApi: '/resserv' });
}

/**
 * 保存项目
 * https://yapi.lanhanba.com/project/399/interface/api/58253
 */
export function postPlaceCreate(params: any) {
  return post('/tenant/place/create', { ...params }, { proxyApi: '/resserv' });
}

/**
 * 申请归属
 */
export function applyOwn(tenantPlaceId: number): Promise<any> {
  return post('/property/place/own', { id: tenantPlaceId }, { needHint: true });
}


/**
 * 项目列表表单动态筛选项
 * https://yapi.lanhanba.com/project/319/interface/api/64049
 */
export function postPlaceDynamicFilter() {
  return post('/property/place/dynamicFilter', { }, true);
}

/**
 *  检查项目是否有归属人 认领人
 */
export function getvalidateProjectOwner(params: any) {
  return post('/property/place/relation/role/checkCanBeClaim', { ...params }, {
  });
}


/**
 *  检查项目认领是否达到上限
 */

export function getvalidateProjectOwnerCount(params: any) {
  return post('/property/place/claimLimit/reached', { ...params }, {
  });
}


export default placeMap;
